import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const stayAiSettings = defineIntegrationSettings({
  fields: {},
  secrets: { apiKey: z.string().trim().min(1, "Stay AI API key is required.") },
  connectOnly: {},
  computed: {},
});
